export default __webpack_public_path__ + "static/media/sleigh-bells.98e46b0c.jpg";